import { render, staticRenderFns } from "./LogsSqlData.vue?vue&type=template&id=1894ea85&"
import script from "./LogsSqlData.vue?vue&type=script&lang=js&"
export * from "./LogsSqlData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports